var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 按团长统一限制每日积分核销。该团长对所有用户共用每日扫码次数和积分额度，填 0 表示不限；只有状态为“启用”的配置会拦截核销。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "团长uid" } },
                [
                  _c("el-input", {
                    staticClass: "selWidthSm",
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.query.leaderUid,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "leaderUid", _vm._n($$v))
                      },
                      expression: "query.leaderUid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidthSm",
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "启用", value: 1 } }),
                      _c("el-option", { attrs: { label: "停用", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.load(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.openCreate },
                    },
                    [_vm._v("新增配置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              false
                ? _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "团长", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", [
                          _vm._v(_vm._s(_vm.userName(row.leaderUid))),
                        ]),
                        _c("div", { staticClass: "sub-line" }, [
                          _vm._v(
                            "uid " +
                              _vm._s(row.leaderUid) +
                              _vm._s(_vm.userPhone(row.leaderUid))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "每日次数上限", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.dailyScanLimit > 0 ? row.dailyScanLimit : "不限"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "每日积分上限", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            row.dailyPointsLimit > 0
                              ? row.dailyPointsLimit
                              : "不限"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "今日已用", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(_vm.today(row) ? row.usedScanCount || 0 : 0) +
                            " 次 / " +
                            _vm._s(_vm.today(row) ? row.usedPoints || 0 : 0) +
                            " 分"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: row.status === 1 ? "success" : "info",
                            },
                          },
                          [_vm._v(_vm._s(row.status === 1 ? "启用" : "停用"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openEdit(row)
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                        row.status === 1
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.disable(row)
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pager" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  total: _vm.total,
                },
                on: { "size-change": _vm.onSize, "current-change": _vm.load },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.form.id ? "修改核销限额" : "新增核销限额",
            visible: _vm.dialogVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "团长uid", prop: "leaderUid" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth",
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        disabled: !!_vm.form.id,
                        "remote-method": _vm.searchLeader,
                        loading: _vm.leaderLoading,
                        placeholder: "请选择门店团长",
                      },
                      model: {
                        value: _vm.form.leaderUid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "leaderUid", $$v)
                        },
                        expression: "form.leaderUid",
                      },
                    },
                    _vm._l(_vm.leaderList, function (item) {
                      return _c("el-option", {
                        key: item.uid,
                        attrs: {
                          label: _vm.leaderLabel(item),
                          value: item.uid,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "每日扫码次数", prop: "dailyScanLimit" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 999999,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.dailyScanLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dailyScanLimit", $$v)
                      },
                      expression: "form.dailyScanLimit",
                    },
                  }),
                  _c("span", { staticClass: "hint" }, [_vm._v("0 表示不限")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "每日积分额度", prop: "dailyPointsLimit" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 999999999,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.form.dailyPointsLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dailyPointsLimit", $$v)
                      },
                      expression: "form.dailyPointsLimit",
                    },
                  }),
                  _c("span", { staticClass: "hint" }, [_vm._v("0 表示不限")]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "停用",
                    },
                    model: {
                      value: _vm.form.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "status", $$v)
                      },
                      expression: "form.status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }